import { FeatureFlags } from '../../../../../../../../../components/Authorizer';
import { CodeStatuses } from '../../../../../../../../../constants/codes';
import { actionTypes } from '../util';

const quickFilters = [
  {
    name: 'codeApplied',
    searchKey: 'code.letter.keyword',
    data: [],
    selected: [],
    placeholder: 'Code Applied',
    idKey: 'letter',
    labelKey: 'letter',
    flag: FeatureFlags.Codes
  },
  {
    name: 'codeStatus',
    searchKey: 'action',
    data: [
      { value: actionTypes.codeApplied, text: CodeStatuses.Applied },
      { value: actionTypes.codeSuggested, text: CodeStatuses.Suggested },
      { value: actionTypes.codeWaived, text: CodeStatuses.Waived },
      { value: actionTypes.codeInquiring, text: CodeStatuses.Inquiring },
      { value: actionTypes.codeRemovalSuggested, text: 'removal suggested' },
      { value: actionTypes.codeCleared, text: 'cleared' }
    ],
    selected: [],
    placeholder: 'Code Status',
    idKey: 'value',
    labelKey: 'text',
    flag: FeatureFlags.Codes
  },
  {
    name: 'record',
    searchKey: 'insurance_requirement.id',
    data: [],
    selected: [],
    placeholder: 'Records',
    idKey: 'id',
    labelKey: record => {
      const { contractNumber, job: { jobName }, archivedAt, deletedAt } = record;

      // eslint-disable-next-line no-nested-ternary
      const state = `${deletedAt ? '(Deleted) ' : archivedAt ? '(Archived) ' : ''}`;

      if (contractNumber) {
        return `${state}${jobName} - ${contractNumber}`;
      }

      return `${state}${jobName}`;
    }
  },
  {
    name: 'user',
    searchKey: 'user.id',
    data: [],
    selected: [],
    placeholder: 'User',
    idKey: 'userId',
    labelKey: user => (user.userFirstName && user.userLastName
      ? `${user.userFirstName} ${user.userLastName}`
      : user.userEmail)
  },
  {
    name: 'type',
    searchKey: 'action',
    selected: [],
    placeholder: 'Action Type',
    idKey: 'value',
    labelKey: 'text',
    data: Object.values(actionTypes).map(type => ({
      value: type,
      text: type.replace(/_/g, ' ')
    }))
  }
];

export default quickFilters;
